<template>
    <span :class="['badge', colorClass, light ? 'badge--light' : '', filled ? 'badge--filled' : '']">
        <slot />
    </span>
</template>

<script>
import { computed } from 'vue';

export default {
    name: "BadgeComponent",
    props: {
        type: {
            type: String,
            default: 'default', // default, success, danger, warning, info, primary, offline, online
        },
        light: {
            type: Boolean,
            default: false,
        },
        filled: {
            type: Boolean,
            default: false,
        }
    },
    setup(props) {
        const colorClasses = {
            default: 'badge--default',
            accent: 'badge--accent',
            accentLight: 'badge--accent-light',
            success: 'badge--success',
            danger: 'badge--danger',
            warning: 'badge--warning',
            info: 'badge--info',
            offline: 'badge--offline',
            online: 'badge--online',
            primary: 'badge--primary'

        };

        const colorClass = computed(() => colorClasses[props.type] || 'badge--default');

        return { colorClass };
    }
};
</script>

<style scoped lang="scss">
.badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    font-weight: 500;
    padding: 6px 12px;
    border-radius: 12px;
    border: 1px solid transparent;
    color: white;
    line-height: 1;
    user-select: none;
    transition: all 0.3s ease;
    background-color: rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(6px);
}

// Серый фон, иконки пользователей, страны
.badge--default {
    background-color: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.1);
    color: #e6e6e6;
}

// Фиолетовые бейджи с градиентом
.badge--accent {
    background: linear-gradient(135deg, #a365f8, #7a42ee);
    border-color: rgba(194, 145, 255, 0.3);
    color: white;
    box-shadow:
        inset 0 1px 1px rgba(255, 255, 255, 0.1),
        0 0 4px rgba(155, 92, 247, 0.5);
}

.badge--accent-light {
    background: linear-gradient(135deg, #dfcaff, #ceb5ff);
    border-color: rgb(102 63 151 / 32%);
    color: #61449e;
    box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.1), 0 0 4px rgb(95 42 172 / 23%);
}

// Статусные цвета
.badge--success {
    background-color: #0f5132;
    border-color: #198754;
    color: #43ff94;
}

.badge--danger {
    background-color: #58151c;
    border-color: #dc3545;
    color: #ff6b6b;
}

.badge--warning {
    background-color: #664d03;
    border-color: #ffc107;
    color: #ffe580;
}

.badge--info {
    background-color: #052c65;
    border-color: #0dcaf0;
    color: #6bdfff;
}

.badge--offline {
    background-color: #440c0c;
    border-color: #842029;
    color: #ff6262;
}

.badge--online {
    background-color: #0a3622;
    border-color: #157347;
    color: #63ff95;
}

.badge--light {
    background-color: #f8f9fa;
    border-color: #dee2e6;
    color: #495057;
}

/* Статусы (filled = цветной фон) */

.badge--success.badge--filled {
    background-color: #22c55e;
    color: white;
    border-color: #22c55e;
}

.badge--danger.badge--filled {
    background-color: #ef4444;
    color: white;
    border-color: #ef4444;
}

.badge--warning.badge--filled {
    background-color: #f97316;
    color: white;
    border-color: #f97316;
}

.badge--info.badge--filled {
    background-color: #4e79d1;
    color: white;
    border-color: #6b7280;
}

.badge--primary.badge--filled {
    background-color: #3b82f6;
    color: white;
    border-color: #3b82f6;
}

.badge--offline.badge--filled {
    background-color: #f87171;
    color: white;
    border-color: #f87171;
}

.badge--online.badge--filled {
    background-color: #4ade80;
    color: white;
    border-color: #4ade80;
}

/* Лайт-моды (обводка + светлый фон) */

.badge--success.badge--light {
    background-color: #ecfdf5;
    color: #15803d;
    border-color: #bbf7d0;
}

.badge--danger.badge--light {
    background-color: #fef2f2;
    color: #b91c1c;
    border-color: #fecaca;
}

.badge--warning.badge--light {
    background-color: #fff7ed;
    color: #b45309;
    border-color: #fdba74;
}

.badge--info.badge--light {
    background-color: #f3f4f6;
    color: #374151;
    border-color: #d1d5db;
}

.badge--primary.badge--light {
    background-color: #eff6ff;
    color: #1d4ed8;
    border-color: #bfdbfe;
}

.badge--offline.badge--light {
    background-color: #fef2f2;
    color: #b91c1c;
    border-color: #fecaca;
}

.badge--online.badge--light {
    background-color: #ecfdf5;
    color: #15803d;
    border-color: #bbf7d0;
}
</style>